<template>
  <main class="customer">
<div v-show="checkHideContents(FirstLayer)">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1>Connect</h1>
        </div>
        <nav>
          <ul>
<li><p>フォームからお気軽にお問い合わせください。</p><router-link to="/customer/contact" class="pageLinkButton pageLinkSquareButton">コンタクトフォーム</router-link></li>
<!--
<li><p>多く寄せられたご質問を掲載しています。</p><router-link to="/customer/faq" class="pageLinkButton pageLinkSquareButton">FAQ</router-link></li>
-->
<li><p>ご来社される場合は、連絡の上お越しください。</p><router-link :to="{path:'/about', hash:'AboutAccess'}" class="pageLinkButton pageLinkSquareButton">地図</router-link></li>
          </ul>
        </nav>
      </div>
    </div>
</div>

    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: 'customer',
  components:{
  },
  data: function () {
    return {
			pageTitle:"お客様窓口",
			description:"お客様用のアクセス情報です。フォーム、電話、メールアドレス、MAPを用意しています。",
			keywords:"お客様窓口",
			ogType:"article",
		}
	},
  mounted: function() {console.log("mounted "+this.$options.name)
/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')
	
/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
  updated: function() {console.log("updated "+this.$options.name)
/*子が呼び出されているときは、以下をセットしないようにしないといけない*/
		if( !this.checkHierarchy()) {
			this.$store.commit('updatePageSectionInfo', this.gatherTagId())
			this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
			this.$store.commit('updateCurrentTitle', this.pageTitle)
			this.$store.commit('updateCurrentDescription', this.description)
			this.$store.commit('updateCurrentKeywords', this.keywords)
			this.$store.commit('updateCurrentOgUrl', this.isUrl)
			this.$store.commit('updateCurrentOgType', this.ogType)
			this.$store.commit('updateCurrentOgDesc', this.description)
			this.$store.commit('updateLinkCanonical', '')
			this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
		}
  },
}
</script>

<style>
</style>